// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { EXPIRE_CURRENT_ORDER_CONFIGURATION } from './constants/expire-order.service.constants';

const expireCurrentOrderService = async (): Promise<[null, Response]> =>
  apiUtils.post(EXPIRE_CURRENT_ORDER_CONFIGURATION);

export { expireCurrentOrderService };
